/**
 * WordPress dependencies
 */
export * from '@wordpress/notices';
